import * as Yup from 'yup'

const ShopOrderFormValidations = () => {
  return Yup.object().shape({
    shopProductName: Yup.string()
      .min(2, 'Minimum 2 symbols')
      .max(45, 'Maximum 45 symbols')
      .required('Name is required'),
  })
}

export { ShopOrderFormValidations }
